// extracted by mini-css-extract-plugin
module.exports = {"TableContainer":"Table_TableContainer__6DE1Q","Table":"Table_Table__2s7JZ"};